import { useState } from 'react'
import { Copy, Check } from 'lucide-react'

/**
 * A copyable command or prompt block.
 *
 * Trainees retype commands wrong — a missing quote in a curl command produces
 * an error message that tells them nothing useful. Everything they're meant to
 * run should be one click away.
 */
export default function CopyBlock({ text, label = 'Copy', children, className = '' }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard access can be refused (insecure context, permissions).
      // The text is visible and selectable either way.
      setCopied(false)
    }
  }

  return (
    <div className={`relative rounded-lg border border-slate-700 bg-slate-900 ${className}`}>
      <button
        onClick={handleCopy}
        className="absolute right-2 top-2 inline-flex items-center gap-1.5 rounded-md
                   bg-slate-700/80 px-2.5 py-1 text-xs font-medium text-slate-100
                   transition-colors hover:bg-slate-600"
      >
        {copied ? <><Check className="h-3 w-3" /> Copied</> : <><Copy className="h-3 w-3" /> {label}</>}
      </button>
      <pre className="overflow-x-auto p-4 pr-24 text-xs leading-relaxed text-slate-100">
        <code>{children ?? text}</code>
      </pre>
    </div>
  )
}
